import { Controller } from "@hotwired/stimulus"
import { waitForTurnstile } from "../utils/turnstile"

// Explicit Turnstile widget. Use with ?render=explicit script (see CloudflareTurnstile::SCRIPT_URL).
// Dispatches bubbled events: turnstile:verified, turnstile:expired, turnstile:error.
// Optional targets: widget (mount), response (hidden inputs), submit (buttons to unlock).
export default class extends Controller {
  static targets = ["widget", "response", "submit"]
  static values = {
    siteKey: String,
    theme: { type: String, default: "light" },
    size: { type: String, default: "flexible" },
    language: { type: String, default: "en" },
    appearance: { type: String, default: "always" },
    execution: { type: String, default: "render" },
  }

  connect() {
    this.widgetId = null
    this.disconnected = false
    this.renderWidget()
  }

  disconnect() {
    this.disconnected = true
    this.removeWidget()
  }

  renderWidget() {
    waitForTurnstile().then(() => {
      if (this.disconnected || this.widgetId !== null) return

      const mount = this.mountElement()
      mount.replaceChildren()

      this.widgetId = window.turnstile.render(mount, {
        sitekey: this.siteKeyValue,
        theme: this.themeValue,
        size: this.sizeValue,
        language: this.languageValue,
        appearance: this.appearanceValue,
        execution: this.executionValue,
        callback: (token) => this.handleSuccess(token),
        "expired-callback": () => this.handleExpired(),
        "error-callback": () => this.handleError(),
      })
    }).catch(() => {
      this.handleError()
    })
  }

  removeWidget() {
    if (this.widgetId === null || !window.turnstile) return

    window.turnstile.remove(this.widgetId)
    this.widgetId = null
  }

  mountElement() {
    return this.hasWidgetTarget ? this.widgetTarget : this.element
  }

  handleSuccess(token) {
    this.responseTargets.forEach((el) => {
      el.value = token
    })
    this.submitTargets.forEach((el) => {
      el.disabled = false
    })
    this.dispatch("verified", { detail: { token } })
  }

  handleExpired() {
    this.clearResponses()
    this.disableSubmits()
    this.dispatch("expired")
  }

  handleError() {
    this.clearResponses()
    this.disableSubmits()
    this.dispatch("error")
  }

  clearResponses() {
    this.responseTargets.forEach((el) => {
      el.value = ""
    })
  }

  disableSubmits() {
    this.submitTargets.forEach((el) => {
      el.disabled = true
    })
  }
}
